import { Outlet, Navigate } from "react-router-dom"
import { useSelector } from "react-redux";
import { Cookie } from "../app/base/utils";

const UserValidation = () => {
  const _login: any = useSelector((state: any) => state.login.login);
  const _loginCredentials: any = useSelector((state: any) => state.login.loginCred);
  const token: any = Cookie.get();
  return (
     _login?.extension != undefined && token.ssoToken != undefined ? <Outlet /> : <Navigate to="/" />
   // _login?.extension != undefined ? <Outlet /> : <Navigate to="/" />
  )
  /* return (
    token && _login.isLoggedIn ? <Outlet /> : <Navigate to="/login" />
  ) */
}

export default UserValidation;